import { getOrderItemsByItemId } from './get-order-items-by-item-id';
export const getOrderPriceRestrictionsForItem = (itemId) => {
    const uniqueDiscountIds = new Set();
    const uniqueRewardIds = new Set();
    getOrderItemsByItemId(itemId).forEach(item => {
        if (item.discountId)
            uniqueDiscountIds.add(item.discountId);
        if (item.rewardId)
            uniqueRewardIds.add(item.rewardId);
    });
    const restrictions = [];
    uniqueDiscountIds.forEach(discountId => restrictions.push({ discountId }));
    uniqueRewardIds.forEach(rewardId => restrictions.push({ rewardId }));
    return restrictions;
};
